import React, {useEffect, useState} from 'react'
import {LoadingSpinner} from '../../../utils/loading/loadingSpinner'
import {getMedicalRecordsByPersonId} from '../../../coreGlobal/_resquest'
import {formatDateTime, formatDateTimeHM} from '../../../utils/dayJs/format'
import {SaleItemResponse} from '../../../coreGlobal/models/sale'
import {MedicalRecordModal} from './MedicalRecordModal'
import {KTIcon} from '../../../_metronic/helpers'
import {useAuth} from '../../../app/modules/auth'

interface IPeopleID {
  peopleId: number | null
}

function changeIcons(status: number | undefined, medicalRecordStatus: string) {
  if (status === undefined) {
    // Sem agendamento vinculado
    return medicalRecordStatus === 'Realizado' ? (
      <KTIcon iconName='like' className='fs-1 text-success' />
    ) : (
      <KTIcon iconName='check-circle' className='fs-1 text-muted' />
    )
  } else if (status === 8 && medicalRecordStatus !== 'Realizado') {
    //cancelado
    return <KTIcon iconName='cross-circle' className='fs-1 text-danger' />
  } else if (status === 8 || (status === 7 && medicalRecordStatus === 'Realizado')) {
    //finalizado
    return <KTIcon iconName='like' className='fs-1 text-success' />
  } else if (status === 1 || status === 2) {
    //Agendado || confirmado
    return <KTIcon iconName='book' className='fs-1 text-warning' />
  } else if (status === 3 || status === 7) {
    //Compareceu || autorizado
    return <KTIcon iconName='check-circle' className='fs-1 text-success' />
  }
}
export const ListMedicalRecords = ({peopleId}: IPeopleID) => {
  const {currentUser} = useAuth()
  const canUpdateFinished = currentUser?.permissions.includes('medicalRecords.update_finished')
  const [showMedicalRecordModal, setShowMedicalRecordModal] = useState<boolean>(false)
  const [medicalRecord, setMedicalRecord] = useState<any>(null)

  const [loading, setLoading] = useState(false)
  const [saleItems, setSaleItems] = useState<SaleItemResponse[]>()

  const fetchMedicalRecords = async () => {
    setLoading(true)
    if (peopleId) {
      setSaleItems(await getMedicalRecordsByPersonId(peopleId))
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchMedicalRecords()
  }, [])
  return (
    <>
      <div className='card-header cursor-pointer mb-5'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>
            Informações do Prontuário | Agendado:{' '}
            <KTIcon iconName='book' className='fs-1 text-warning' /> | Compareceu:{' '}
            <KTIcon iconName='check-circle' className='fs-1 text-success' /> | Evoluido:{' '}
            <KTIcon iconName='like' className='fs-1 text-success' /> | Cancelado:{' '}
            <KTIcon iconName='cross-circle' className='fs-1 text-danger' /> |
          </h3>
        </div>
      </div>
      {loading ? (
        <LoadingSpinner
          title='Carregando'
          style={{
            width: '2rem',
            height: '2rem',
            colorSpinner: '#f1416c',
            colorText: '#f1416c',
          }}
        />
      ) : (
        <>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table table-bordered table-row-gray-300 gy-7'>
                {saleItems?.map((item, index) => {
                  return (
                    <React.Fragment key={`saleItemsTr${index}`}>
                      <thead>
                        <tr className='table-active'>
                          <th colSpan={9}>
                            {`Contrato: ${item.saleId} | ${item.product.id} - ${
                              item.product.name
                            } | Data contrato: ${formatDateTime(
                              String(item.sale?.createdAt)
                            )} | Total de sessões: ${item.sessions}`}
                          </th>
                        </tr>
                        <tr className='fw-bolder fs-6 text-gray-800 table-active'>
                          <th>Sessão</th>
                          <th>Status</th>
                          <th>Data Agendamento</th>
                          <th>Data Prontuário</th>
                          <th>Parametros</th>
                          <th>Profissional</th>
                          <th>Alterado Por</th>
                          <th>Observação</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.medicalRecords?.map((medicalRecord, index) => {
                          const scheduleStatusId =
                            medicalRecord.scheduleItem?.schedule?.lastHistory?.status_id
                          const scheduleStatus =
                            scheduleStatusId === undefined ? undefined : Number(scheduleStatusId)
                          return (
                            <tr key={`medicalRecordsTr${index}`}>
                              <td className='text-center'>{medicalRecord.sessionNumber}</td>
                              <td className='text-center'>
                                {changeIcons(scheduleStatus, medicalRecord.status)}
                              </td>
                              <td className='text-center'>
                                {medicalRecord.scheduleItem?.schedule?.dateInit
                                  ? formatDateTimeHM(medicalRecord.scheduleItem.schedule.dateInit)
                                  : '-'}
                              </td>
                              <td className='text-center'>
                                {formatDateTimeHM(medicalRecord.createdAt)}
                              </td>
                              <td className='text-center'>{medicalRecord.machineFrequency}</td>
                              <td className='text-center'>{medicalRecord.attendant?.name}</td>
                              <td className='text-center'>{medicalRecord.user?.name}</td>
                              <td>{medicalRecord.observation}</td>
                              <td className='text-center'>
                                {canUpdateFinished && (
                                  <button
                                    onClick={() => {
                                      setMedicalRecord(medicalRecord)
                                      setShowMedicalRecordModal(true)
                                    }}
                                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                  >
                                    <KTIcon iconName='gear' className='fs-3' />
                                  </button>
                                )}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </React.Fragment>
                  )
                })}
              </table>
            </div>
          </div>
        </>
      )}
      {showMedicalRecordModal && (
        <MedicalRecordModal
          medicalRecord={medicalRecord}
          close={() => {
            setShowMedicalRecordModal(false)
            setMedicalRecord(null)
          }}
          onSaved={fetchMedicalRecords}
        />
      )}
    </>
  )
}
